import { TableHeader } from "../table";

/**
 * Maps a raw row object into the CellData array for the current headers.
 *
 * @param rowData - Source row object
 * @param sortedTableHeaders - Headers in display order
 * @returns Cell descriptors for one row
 */
export function transformRowData(
  rowData: Record<string, any>,
  sortedTableHeaders: TableHeader[],
) {
  return sortedTableHeaders.map((header) => {
    const key = header.key;
    let value = rowData[key] !== undefined ? rowData[key] : "";

    if (
      header.subKey &&
      value &&
      typeof value === "object" &&
      header.type === "string"
    ) {
      value = value[header.subKey] !== undefined ? value[header.subKey] : "";
    }

    return {
      value,
      type: header.type,
      width: header.width,
      header: key,
      rowData: rowData,
      fieldKey: key,
      originalRowData: rowData,
    };
  });
}

/**
 * Resolves the global row for a page-relative index.
 *
 * @param tableData - Full dataset
 * @param rowIndex - Index within the current page
 * @param startIndex - Global start index of the page
 * @returns Row object at the absolute index
 */
export function getRowDataToPass(
  tableData: any[],
  rowIndex: number,
  startIndex: number,
) {
  const rowDataToPassIndex = rowIndex + startIndex;
  return tableData[rowDataToPassIndex];
}
